import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import moment from "moment";
import AllZonesMap from "views/pages/zoning/all-zones-map";
import {
  getZoneAll,
  addZone
} from "actions/zone/actions";

const ViewAllZones = ({
                        getZoneAll,
                        zoneAll,
                        addZone
                      }) => {
  const handleEndNow = (zone) => {
    const currentZone = zoneAll.find(item => item.id === zone.id);
    if (currentZone) {
      currentZone.end = moment()
        .valueOf();
      addZone(currentZone);
    }
  };

  useEffect(() => {
    getZoneAll();
  }, [getZoneAll]);

  const places = zoneAll
    .filter(item => item.end > moment()
      .valueOf())
    .map(item => ({
      id: item.id,
      title: item.name,
      bonus: item.bonus,
      description: item.description,
      latitude: item.latitude,
      longitude: item.longitude,
      circle: {
        radius: item.radius,
        clickable: false,
        options: {
          strokeColor: item.type,
          fillColor: item.type,
          fillOpacity: 0.4,
          strokeWeight: 1,
          zIndex: -1
        }
      }
    }));
  return (
    <div>
      <AllZonesMap
        googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCC-gpzzG6hcmAyagvaYCc23KAy4rIkv2A&v=3.exp&libraries=geometry,drawing,places,visualization"
        loadingElement={<div style={{ height: 600 }}/>}
        containerElement={<div style={{ minHeight: 600 }}/>}
        mapElement={<div style={{ minHeight: 600 }}/>}
        places={places}
        handleEndNow={handleEndNow}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  zoneAll: state.zone.zoneAll,
});

const mapStateToDispatch = dispatch => ({
  getZoneAll: bindActionCreators(getZoneAll, dispatch),
  addZone: bindActionCreators(addZone, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(ViewAllZones);



// WEBPACK FOOTER //
// ./src/views/pages/zoning/view-all-zones.js